/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';

const tags = {
  largest: 'h1',
  large: 'h2',
  default: 'h3',
  small: 'h4',
  smallest: 'h5',
  section: 'h3',
};

const nowrapStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
/** @typedef {import('./titleVariants').TitleVariant} TitleVariant */
/**
 * @param {object} props
 * @param {TitleVariant} [props.variant]
 * @param {React.ElementType} [props.as]
 * @param {boolean} [props.nowrap]
 * @param {React.ReactNode} props.children
 */
export default function Title({
  variant = 'default',
  as = tags[variant] || tags.default,
  nowrap = false,
  children,
  ...rest
}) {
  return (
    <Box
      as={as}
      sx={{
        margin: 0,
        padding: 0,
        variant: `title.${variant}`,
        ...(nowrap && nowrapStyle),
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
